import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartTextBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartTextBlock'

export class FlowChartTextBlockBuilder {
  private block: FlowChartTextBlock

  constructor(id: string) {
    this.block = {
      id,
      type: FlowChartBlockType.TEXT,
      data: {
        text: '',
        buttons: [],
      },
    }
  }

  withText(text: string): FlowChartTextBlockBuilder {
    this.block.data.text = text
    return this
  }

  withButtons(buttons: FlowChartButton[]): FlowChartTextBlockBuilder {
    this.block.data.buttons = buttons
    return this
  }

  build(): FlowChartTextBlock {
    return this.block
  }
}
